export enum SortOrder {
    Descending = "descend",
    Ascending = "ascend",
}
